import type {
    SadadBillPaymentMethod,
    SadadBillPaymentType,
    SadadBillServiceType,
    SadadBillStatus,
    SadadBillType,
} from '@/types/models';

const enumMap = {
    CIP: 1,
    ELCT: 2,
    PHON: 3,
    GSM: 4,
    LLIN: 5,
    INSR: 6,
    BKSV: 7,
    GOVT: 8,
    MED: 9,
    CCRD: 10,
    UTIL: 11,
    PCIN: 12,
    EXAM: 13,
} as const;

export type SadadBillServiceTypeEnumKeys = keyof typeof enumMap;
export type SadadBillServiceTypeEnumValues =
    (typeof enumMap)[SadadBillServiceTypeEnumKeys];

export const sadadBillServiceTypeEnum: SadadBillServiceType extends SadadBillServiceTypeEnumValues
    ? typeof enumMap
    : never = enumMap;

const billStatusEnumMap = {
    PAID: 1,
    PARTIAL_PAID: 2,
    OVER_PAID: 3,
    UNPAID: 4,
    DEACTIVATED: 5,
} as const;

export type SadadBillStatusEnumKeys = keyof typeof billStatusEnumMap;
export type SadadBillStatusEnumValues =
    (typeof billStatusEnumMap)[SadadBillStatusEnumKeys];

export const sadadBillStatusEnum: SadadBillStatus extends SadadBillStatusEnumValues
    ? typeof billStatusEnumMap
    : never = billStatusEnumMap;

const billTypeEnumMap = {
    POSTPAID: 1,
    PREPAID: 2,
} as const;

export type SadadBillTypeEnumKeys = keyof typeof billTypeEnumMap;
export type SadadBillTypeEnumValues =
    (typeof billTypeEnumMap)[SadadBillTypeEnumKeys];

export const sadadBillTypeEnum: SadadBillType extends SadadBillTypeEnumValues
    ? typeof billTypeEnumMap
    : never = billTypeEnumMap;

const billPaymentTypeEnumMap = {
    POST: 1,
    RCHG: 2,
} as const;

export type SadadBillPaymentTypeEnumKeys = keyof typeof billPaymentTypeEnumMap;
export type SadadBillPaymentTypeEnumValues =
    (typeof billPaymentTypeEnumMap)[SadadBillPaymentTypeEnumKeys];

export const sadadBillPaymentTypeEnum: SadadBillPaymentType extends SadadBillPaymentTypeEnumValues
    ? typeof billPaymentTypeEnumMap
    : never = billPaymentTypeEnumMap;

const billPaymentMethodEnumMap = {
    ACTDEB: 1,
} as const;

export type SadadBillPaymentMethodEnumKeys =
    keyof typeof billPaymentMethodEnumMap;
export type SadadBillPaymentMethodEnumValues =
    (typeof billPaymentMethodEnumMap)[SadadBillPaymentMethodEnumKeys];

export const sadadBillPaymentMethodEnum: SadadBillPaymentMethod extends SadadBillPaymentMethodEnumValues
    ? typeof billPaymentMethodEnumMap
    : never = billPaymentMethodEnumMap;
